@if (showFetchLoader) {
<div class="paginate-loader" role="status" aria-label="Loading">
  <div class="paginate-loader__dots">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <span class="paginate-loader__text">Loading more</span>
</div>
}
